/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Clear cart button (rendered by snippets/clear-cart.liquid).
 *
 * Clicking the "Clear cart" link reveals an inline confirmation instead of the
 * native confirm() dialog. Confirming POSTs to Shopify's /cart/clear.js, then
 * either reloads the page (on the cart page) or dispatches the theme's
 * "cart:refresh" event so the mini-cart drawer and header count re-render.
 */
(function () {
  function showConfirm(rootElement, visible) {
    var trigger = rootElement.querySelector('.clear-cart__trigger'),
      confirmBox = rootElement.querySelector('.clear-cart__confirm');

    if (visible) {
      trigger.setAttribute('hidden', '');
      confirmBox.removeAttribute('hidden');
      confirmBox.querySelector('[data-action="cancel-clear-cart"]').focus();
    } else {
      confirmBox.setAttribute('hidden', '');
      trigger.removeAttribute('hidden');
      trigger.focus();
    }
  }

  function clearCart(rootElement) {
    rootElement.querySelectorAll('.clear-cart__confirm-button').forEach(function (button) {
      button.disabled = true;
    });

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(window.routes.cartUrl + '/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Could not clear the cart (status ' + response.status + ')');
        }

        if (window.theme.pageType === 'cart') {
          window.location.reload();
        } else {
          // The Cart component re-renders the mini-cart and dispatches
          // "theme:loading:end" itself once it is done.
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { source: 'clear_cart' }
          }));
        }
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        rootElement.querySelectorAll('.clear-cart__confirm-button').forEach(function (button) {
          button.disabled = false;
        });

        showConfirm(rootElement, false);
      });
  }

  document.addEventListener('click', function (event) {
    var actionElement = event.target.closest('[data-action="clear-cart"], [data-action="confirm-clear-cart"], [data-action="cancel-clear-cart"]');

    if (!actionElement) {
      return;
    }

    var rootElement = actionElement.closest('.clear-cart');

    switch (actionElement.getAttribute('data-action')) {
      case 'clear-cart':
        event.preventDefault();
        showConfirm(rootElement, true);
        break;

      case 'cancel-clear-cart':
        showConfirm(rootElement, false);
        break;

      case 'confirm-clear-cart':
        clearCart(rootElement);
        break;
    }
  });
})();

/**
 * qikify Sticky Cart drawer integration for the clear cart button.
 *
 * The qikify "Sticky Cart v2" app intercepts the header cart icon and renders
 * its own drawer instead of the theme's mini-cart, so the clear cart button in
 * snippets/clear-cart.liquid would never be seen there. This clones the
 * (hidden) mini-cart instance of the button into the qikify drawer footer.
 *
 * - The clone reuses the Liquid-rendered markup, so translations come for free
 *   and the delegated click handler above works on it unchanged.
 * - qikify is a Vue app that unmounts/remounts the drawer DOM as it opens,
 *   closes and re-renders, which silently drops foreign nodes. A
 *   MutationObserver re-injects the button whenever that happens (the inject
 *   function is idempotent, so observer feedback is a no-op).
 * - After a successful clear, qikify notices the cart change on its own (it
 *   watches cart AJAX calls) and swaps to its empty-cart state; the
 *   "cart:refresh" dispatched by the handler above updates the theme header.
 * - If the app is ever uninstalled or its DOM changes, this does nothing and
 *   the theme's own drawer button (mini-cart.liquid) takes over.
 */
(function () {
  var QIKIFY_ROOT_SELECTOR = '#qikify-stickycart-v2-app';
  var QIKIFY_FOOTER_SELECTOR = '.qsc2-drawer-footer';

  function inject(appRoot) {
    if (appRoot.querySelector('.clear-cart')) {
      return;
    }

    var sourceElement = document.querySelector('.mini-cart .clear-cart'),
      footerElement = appRoot.querySelector(QIKIFY_FOOTER_SELECTOR);

    if (!sourceElement || !footerElement) {
      return;
    }

    var clone = sourceElement.cloneNode(true);
    clone.classList.remove('clear-cart--mini-cart');
    clone.classList.add('clear-cart--qikify');
    footerElement.insertBefore(clone, footerElement.firstChild);
  }

  function watch(appRoot) {
    new MutationObserver(function () {
      inject(appRoot);
    }).observe(appRoot, { childList: true, subtree: true });

    inject(appRoot);
  }

  function init() {
    var appRoot = document.querySelector(QIKIFY_ROOT_SELECTOR);

    if (appRoot) {
      watch(appRoot);
      return;
    }

    // The app embed may mount after this script runs; watch for it briefly.
    var bodyObserver = new MutationObserver(function () {
      var root = document.querySelector(QIKIFY_ROOT_SELECTOR);

      if (root) {
        bodyObserver.disconnect();
        watch(root);
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      bodyObserver.disconnect();
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Fallback cart:refresh for apps that break the BuyButton promise chain.
 *
 * Some cart-drawer apps (e.g. qikify Sticky Cart) wrap window.fetch and, when
 * they detect a /cart/add request, handle the response internally (to show
 * their own drawer) but return a dead promise to the caller. This prevents the
 * theme's BuyButton from dispatching "product:added", so the header cart count
 * never updates.
 *
 * This workaround intercepts fetch calls to /cart/add.js. On a successful
 * response it schedules a "cart:refresh" event after 300 ms. If the theme's
 * own "product:added" fires within that window (as it does on pages where the
 * promise chain is intact), the scheduled refresh is cancelled to avoid a
 * redundant re-render.
 */
(function () {
  var _cartRefreshTimer = null;

  document.documentElement.addEventListener('product:added', function () {
    if (_cartRefreshTimer) {
      clearTimeout(_cartRefreshTimer);
      _cartRefreshTimer = null;
    }
  });

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      return origFetch.apply(this, arguments).then(function (resp) {
        if (resp.ok) {
          _cartRefreshTimer = setTimeout(function () {
            _cartRefreshTimer = null;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { source: 'cart_add_fallback' }
            }));
          }, 300);
        }
        return resp;
      });
    }
    return origFetch.apply(this, arguments);
  };
})();

/**
 * JE-CUSTOM: hide the sticky mobile header while scrolling down and reveal it
 * while scrolling up. The header stays visible near the top of the page and
 * whenever one of its controls, menus or drawers is active.
 */
(function () {
  var MOBILE_QUERY = '(max-width: 999px)';
  var HIDE_THRESHOLD = 12;
  var SHOW_THRESHOLD = 8;
  var mobileMedia = window.matchMedia(MOBILE_QUERY);
  var headerSection = null;
  var stickyHeader = null;
  var lastScrollY = 0;
  var direction = 0;
  var directionDistance = 0;
  var scheduledFrame = null;

  function getScrollY() {
    return Math.max(window.pageYOffset || document.documentElement.scrollTop || 0, 0);
  }

  function setHidden(hidden) {
    if (!stickyHeader) {
      document.documentElement.classList.remove('je-mobile-header-hidden');
      return;
    }

    stickyHeader.classList.toggle('je-header-hidden', hidden);
    document.documentElement.classList.toggle('je-mobile-header-hidden', hidden);
  }

  function resetDirection(scrollY) {
    lastScrollY = scrollY;
    direction = 0;
    directionDistance = 0;
  }

  function hasHeaderFocus() {
    var activeElement = document.activeElement;

    return Boolean(activeElement && headerSection.contains(activeElement));
  }

  function hasActiveHeaderUi() {
    if (!headerSection) {
      return false;
    }

    return document.documentElement.classList.contains('is-locked') ||
      hasHeaderFocus() ||
      Boolean(headerSection.querySelector(
        '.header__mobile-nav-toggle[aria-expanded="true"], ' +
        '.header__cart-toggle[aria-expanded="true"], ' +
        '.header__search-bar-wrapper.is-visible, ' +
        '.header__search-bar-wrapper.is-fixed'
      ));
  }

  function updateHeader() {
    scheduledFrame = null;

    if (!headerSection || !stickyHeader) {
      return;
    }

    var scrollY = getScrollY();

    if (!mobileMedia.matches) {
      setHidden(false);
      resetDirection(scrollY);
      return;
    }

    if (scrollY <= stickyHeader.offsetHeight || hasActiveHeaderUi()) {
      setHidden(false);
      resetDirection(scrollY);
      return;
    }

    var delta = scrollY - lastScrollY;
    var nextDirection = delta > 0 ? 1 : delta < 0 ? -1 : 0;

    lastScrollY = scrollY;

    if (!nextDirection) {
      return;
    }

    if (nextDirection !== direction) {
      direction = nextDirection;
      directionDistance = 0;
    }

    directionDistance += Math.abs(delta);

    if (direction > 0 && directionDistance >= HIDE_THRESHOLD) {
      setHidden(true);
      directionDistance = 0;
    } else if (direction < 0 && directionDistance >= SHOW_THRESHOLD) {
      setHidden(false);
      directionDistance = 0;
    }
  }

  function requestUpdate() {
    if (scheduledFrame === null) {
      scheduledFrame = window.requestAnimationFrame(updateHeader);
    }
  }

  function cancelUpdate() {
    if (scheduledFrame !== null) {
      window.cancelAnimationFrame(scheduledFrame);
      scheduledFrame = null;
    }
  }

  function revealFromInteraction(event) {
    if (!headerSection || !headerSection.contains(event.target)) {
      return;
    }

    cancelUpdate();
    setHidden(false);
    resetDirection(getScrollY());
  }

  function findHeader() {
    var nextHeaderSection = document.querySelector('[data-section-type="header"]');

    if (stickyHeader) {
      stickyHeader.classList.remove('je-header-autohide', 'je-header-hidden');
    }

    document.documentElement.classList.remove('je-mobile-header-hidden');

    headerSection = nextHeaderSection;
    stickyHeader = headerSection ? headerSection.parentElement : null;

    if (!headerSection || !stickyHeader) {
      return;
    }

    var settings = {};

    try {
      settings = JSON.parse(headerSection.getAttribute('data-section-settings') || '{}');
    } catch (error) {
      stickyHeader = null;
      return;
    }

    if (!settings.useStickyHeader) {
      stickyHeader = null;
      return;
    }

    stickyHeader.classList.add('je-header-autohide');
    resetDirection(getScrollY());
    requestUpdate();
  }

  function init() {
    findHeader();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    window.addEventListener('orientationchange', requestUpdate);
    document.addEventListener('focusin', revealFromInteraction);
    document.addEventListener('pointerdown', revealFromInteraction, { passive: true });
    document.addEventListener('click', revealFromInteraction);
    document.addEventListener('shopify:section:load', findHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
